module.exports = __webpack_public_path__ + "static/media/spanner.6346e519.svg";